// extracted by mini-css-extract-plugin
export default {"ObjetTypeRdv":"ObjetTypeRdv_ObjetTypeRdv__Q-VC5","Icone":"ObjetTypeRdv_Icone__nbAvJ","Libelle":"ObjetTypeRdv_Libelle__+jv0b","Duree":"ObjetTypeRdv_Duree__8Z91F"};